<script lang="ts" setup>
import { toRefs, ref } from 'vue';
import Menu from 'primevue/menu';

interface PropsInterface {
  menuItems: {
    label: string;
    command?: () => void; // Explicitly define the function shape
    url?: string;
    icon?: { name: string; styles?: string };
  }[];
  icon?: string;
}

const props = defineProps<PropsInterface>();
const menu = ref<Menu>();
const { menuItems, icon = 'more_horiz' } = toRefs(props);

const toggleMenu = (toggle: Event) => {
  menu.value?.toggle(toggle);
  toggle.stopPropagation();
};

const executeCommand = (command: (() => void) | undefined, event: Event) => {
  event.stopPropagation();
  if (typeof command === 'function') {
    command();
  }
};
</script>

<template>
  <div class="menu__container">
    <span class="material-icons cursor-pointer hover:text-300" @click="toggleMenu">{{ icon }}</span>
    <Menu ref="menu" class="mt-2 ml-2 p-2" :model="menuItems" :popup="true">
      <template #item="{ item }">
        <div class="p-2">
          <a v-if="item.url" :href="item.url">
            <Icon v-if="item.icon" :name="item.icon?.name" :class="item.icon.styles" />
            <span class="relative inline-block pl-2 pt-2 text-sm text-800" v-text="item.label" />
          </a>
          <a v-if="item.command" @click="(event) => executeCommand(item.command, event)">
            <Icon v-if="item.icon" :name="item.icon?.name" :class="item.icon.styles" />
            <span class="relative inline-block pl-2 pt-2 text-sm text-800" v-text="item.label" />
          </a>
        </div>
      </template>
    </Menu>
  </div>
</template>

<style lang="scss" scoped>
a {
  span {
    top: -4px;
  }
}
</style>
